<header
  class="flex sticky top-0 z-50 h-[65px] md:h-[75px] lg:h-[85px] items-center vs:px-4 md:px-8 pt-1 lg:pt-2"
  role="banner"
>
  <div
    class="{{
      'flex w-full items-center ' + (logo ? 'justify-between' : 'justify-end')
    }}"
  >
    @if (logo) {
      <div
        [class]="
          'ml-2 md:ml-4 ' +
          (hasLanguage()
            ? 'max-w-[32%] vs:max-w-[50%] sm:max-w-[70%] md:max-w-[95%]'
            : 'max-w-[55%] vs:max-w-[72%] sm:max-w-[85%] md:max-w-[95%]')
        "
      >
        <img
          [src]="logo"
          class="max-h-[44px] md:max-h-[58px] lg:max-h-[65px] w-auto app-logo"
          [alt]="'language.aria.topbar.logo.alt' | translate"
        />
      </div>
    }
    <div
      class="absolute md:static right-1 md:right-4 flex items-center"
      role="toolbar"
      [attr.aria-label]="'language.aria.controls.labels' | translate"
    >
      @if (hasTheme) {
        <div
          class="high-contrast-btn-style flex items-center gap-3 text-center h-12"
        >
          <app-button
            [icon]="{
              iconType: Icon.Contrast,
              placement: 'right',
              iconClass: 'w-4 h-4 sm:w-6 sm:h-6 md:w-9 md:h-9',
            }"
            buttonId="high-contrast-btn"
            [buttonText]="'navigation.highcontrast.label' | translate"
            [buttonTitle]="'navigation.highcontrast.button' | translate"
            (buttonClick)="toggleHighContrast()"
            customClasses="w-max mr-[4px] vs:mr-3 md:mr-4 transition-transform-slow lg:hover:scale-[1.08] gap-1 sm:gap-2 uppercase font-semibold text-base md:text-lg lg:text-xl"
            [pressed]="highContrast"
            [attr.aria-pressed]="highContrast"
          />
        </div>
      }

      <ng-content select="[appLanguage]"></ng-content>
    </div>
  </div>
</header>
